"use strict";

exports.__esModule = true;
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InputHistory = exports.default = /*#__PURE__*/function () {
  function InputHistory() {
    _classCallCheck(this, InputHistory);
    this.states = [];
    this.currentIndex = 0;
  }
  return _createClass(InputHistory, [{
    key: "currentState",
    get: function get() {
      return this.states[this.currentIndex];
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.states.length === 0;
    }
  }, {
    key: "push",
    value: function push(state) {
      // if current index points before the last element then remove the future
      if (this.currentIndex < this.states.length - 1) this.states.length = this.currentIndex + 1;
      this.states.push(state);
      if (this.states.length > InputHistory.MAX_LENGTH) this.states.shift();
      this.currentIndex = this.states.length - 1;
    }
  }, {
    key: "go",
    value: function go(steps) {
      this.currentIndex = Math.min(Math.max(this.currentIndex + steps, 0), this.states.length - 1);
      return this.currentState;
    }
  }, {
    key: "undo",
    value: function undo() {
      return this.go(-1);
    }
  }, {
    key: "redo",
    value: function redo() {
      return this.go(+1);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.states.length = 0;
      this.currentIndex = 0;
    }
  }]);
}();
InputHistory.MAX_LENGTH = 100;